import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import JobCard from './JobCard';

const JobsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: ${props => props.theme.spacing[2]};

  // Grid for IE11
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: flex;
    flex-wrap: wrap;

    & > * {
      width: 30%;
      box-sizing: border-box;
    }
  }
`;

const Jobs = ({
  jobs,
  onJobCardClick,
  emptyState,
  onPrimaryButtonClick,
  onExpiry,
  onTransferJobClick,
}) => (
  <>
    { jobs.length
      ? (
        <JobsContainer>
          {
            jobs.map(job => (
              <JobCard
                avatars={job.avatars}
                key={job.id}
                isClickable={job.isClickable}
                job={job}
                numberOfWeployees={job.numberOfWeployees}
                onCardClick={onJobCardClick}
                onPrimaryButtonClick={onPrimaryButtonClick}
                onExpiry={onExpiry}
                onTransferJobClick={onTransferJobClick}
                highlighted={job.highlighted}
              />
            ))
          }
        </JobsContainer>
      )
      : emptyState
    }
  </>
);

Jobs.propTypes = {
  emptyState: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  jobs: PropTypes.arrayOf(PropTypes.object).isRequired,
  onExpiry: PropTypes.func,
  onJobCardClick: PropTypes.func,
  onPrimaryButtonClick: PropTypes.func,
  onTransferJobClick: PropTypes.func,
};

Jobs.defaultProps = {
  emptyState: '',
  onExpiry: () => {},
  onJobCardClick: () => {},
  onPrimaryButtonClick: () => {},
  onTransferJobClick: () => {},
};

export default Jobs;
